import { render } from "./BusinessCardCollection.vue?vue&type=template&id=19500414"
import script from "./BusinessCardCollection.vue?vue&type=script&lang=js"
export * from "./BusinessCardCollection.vue?vue&type=script&lang=js"

import "./BusinessCardCollection.vue?vue&type=style&index=0&id=19500414&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__